import React, { useState } from 'react'
import { Dropdown } from 'antd';
import TradeTable from './TradeTable';
import { SearchOutlined, CheckCircleFilled, UserOutlined, SmileOutlined } from '@ant-design/icons';
import { Divider } from 'antd';
import { Col, Row } from 'antd';
import { useLayout } from "../Context/LayoutContext";

const LayoutDrop = ({ children }) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const { switchLayout, activeLay } = useLayout();
    const customPanel = (
        <div className='layout-change'>
            <div className='layout-h-txt'>
                Chart Grids
            </div>

            <div className='p-20'>
                <Row style={{ alignItems: 'center' }} gutter={[16, 16]}>
                    <Col span={10}>
                        <div className='lay-typ'>
                            1 chart
                        </div>
                    </Col>
                    <Col span={14}>
                        <div className={activeLay === "1c" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("1c")}>
                            <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="29" height="24" rx="2" fill="#8E9199" />
                            </svg>


                        </div>
                    </Col>
                    <Divider style={{ margin: "0px 0px", background: '#2D3343' }} />
                    <Col span={10}>
                        <div className='lay-typ'>
                            2 chart
                        </div>
                    </Col>
                    <Col span={14}>
                        <div className='display-1 gap-15'>
                            <div className={activeLay === "2c-l1" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("2c-l1")}>
                                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="27" rx="2" fill="#8E9199" />
                                    <rect x="16" width="14" height="27" rx="2" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "2c-l2" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("2c-l2")}>
                                <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="29.9999" width="14" height="29" rx="2" transform="rotate(-90 0 29.9999)" fill="#8E9199" />
                                    <rect y="13.9999" width="14" height="29" rx="2" transform="rotate(-90 0 13.9999)" fill="#8E9199" />
                                </svg>
                            </div>


                        </div>
                    </Col>
                    <Divider style={{ margin: "0px 0px", background: '#2D3343' }} />
                    <Col span={10}>
                        <div className='lay-typ'>
                            3 chart
                        </div>
                    </Col>
                    <Col span={14}>
                        <div className='display-1 gap-15'>
                            <div className={activeLay === "3c-l1" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("3c-l1")}>
                                <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="28" width="14" height="27" rx="2" transform="rotate(90 28 0)" fill="#8E9199" />
                                    <rect x="14" y="16" width="13" height="14" rx="2" transform="rotate(90 14 16)" fill="#8E9199" />
                                    <rect x="29" y="16" width="13" height="14" rx="2" transform="rotate(90 29 16)" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "3c-l2" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("3c-l2")}>
                                <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="29.9999" width="14" height="29" rx="2" transform="rotate(-90 0 29.9999)" fill="#8E9199" />
                                    <rect y="13.9999" width="14" height="29" rx="2" transform="rotate(-90 0 13.9999)" fill="#8E9199" />
                                </svg>
                            </div>

                            <div className={activeLay === "3c-l4" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("3c-l4")}>
                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="13.9999" width="14" height="14" rx="2" transform="rotate(-90 0 13.9999)" fill="#8E9199" />
                                    <rect y="30" width="14" height="14" rx="2" transform="rotate(-90 0 30)" fill="#8E9199" />
                                    <rect x="16" y="30" width="30" height="14" rx="2" transform="rotate(-90 16 30)" fill="#8E9199" />
                                </svg>
                            </div>

                            <div className={activeLay === "3c-l3" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("3c-l3")}>

                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="14" rx="2" transform="matrix(0 -1 -1 0 30 13.9999)" fill="#8E9199" />
                                    <rect width="14" height="14" rx="2" transform="matrix(0 -1 -1 0 30 30)" fill="#8E9199" />
                                    <rect width="30" height="14" rx="2" transform="matrix(0 -1 -1 0 14 30)" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "3c-l5" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("3c-l5")}>

                                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="25" height="7" rx="2" transform="matrix(0 -1 -1 0 7 25)" fill="#8E9199" />
                                    <rect width="25" height="7" rx="2" transform="matrix(0 -1 -1 0 16 25)" fill="#8E9199" />
                                    <rect width="25" height="7" rx="2" transform="matrix(0 -1 -1 0 25 25)" fill="#8E9199" />
                                </svg>
                            </div>

                        </div>
                    </Col>
                    <Divider style={{ margin: "0px 0px", background: '#2D3343' }} />
                    <Col span={10}>
                        <div className='lay-typ'>
                            4 chart
                        </div>
                    </Col>
                    <Col span={14}>
                        <div className='display-1 gap-15'>
                            <div className={activeLay === "4c-l1" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("4c-l1")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="12" rx="2" fill="#8E9199" />
                                    <rect x="17" width="14" height="12" rx="2" fill="#8E9199" />
                                    <rect y="15" width="14" height="12" rx="2" fill="#8E9199" />
                                    <rect x="17" y="15" width="14" height="12" rx="2" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "4c-l2" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("4c-l2")}>

                                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="8" height="12" rx="2" fill="#8E9199" />
                                    <rect x="11" width="8" height="12" rx="2" fill="#8E9199" />
                                    <rect x="22" width="8" height="12" rx="2" fill="#8E9199" />
                                    <rect y="15" width="30" height="12" rx="2" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "4c-l3" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("4c-l3")}>

                                <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="16.0001" width="8" height="12" rx="2" fill="#8E9199" />
                                    <rect x="11" y="16.0001" width="8" height="12" rx="2" fill="#8E9199" />
                                    <rect x="22" y="16.0001" width="8" height="12" rx="2" fill="#8E9199" />
                                    <rect y="0.00012207" width="30" height="12" rx="2" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "4c-l4" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("4c-l4")}>

                                <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="16" y="30.0003" width="8" height="12" rx="2" transform="rotate(-90 16 30.0003)" fill="#8E9199" />
                                    <rect x="16" y="19.0001" width="8" height="12" rx="2" transform="rotate(-90 16 19.0001)" fill="#8E9199" />
                                    <rect x="16" y="7.99982" width="8" height="12" rx="2" transform="rotate(-90 16 7.99982)" fill="#8E9199" />
                                    <rect y="30" width="30" height="12" rx="2" transform="rotate(-90 0 30)" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "4c-l5" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("4c-l5")}>

                                <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="8" height="12" rx="2" transform="matrix(0 -1 -1 0 12 30.0003)" fill="#8E9199" />
                                    <rect width="8" height="12" rx="2" transform="matrix(0 -1 -1 0 12 19.0001)" fill="#8E9199" />
                                    <rect width="8" height="12" rx="2" transform="matrix(0 -1 -1 0 12 7.99982)" fill="#8E9199" />
                                    <rect width="30" height="12" rx="2" transform="matrix(0 -1 -1 0 28 30)" fill="#8E9199" />
                                </svg>
                            </div>


                        </div>
                    </Col>
                    <Divider style={{ margin: "0px 0px", background: '#2D3343' }} />
                    <Col span={10}>
                        <div className='lay-typ'>
                            More grids
                        </div>
                    </Col>
                    <Col span={14}>
                        <div className='display-1 gap-15'>
                            <div className={activeLay === "mc-l1" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l1")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1" width="30" height="17" rx="2" fill="#8E9199" />
                                    <rect y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                    <rect x="8" y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                    <rect x="16" y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                    <rect x="24" y="21" width="7" height="6" rx="2" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l2" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l2")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="8" width="23" height="27" rx="2" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                    <rect y="14.4" width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                    <rect y="7.20001" width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                    <rect y="21.6" width="6.3" height="5.4" rx="1.8" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "mc-l3" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l3")}>


                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="23" height="27" rx="2" transform="matrix(-1 0 0 1 23 0)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 0)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 14.4)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 7.20001)" fill="#8E9199" />
                                    <rect width="6.3" height="5.4" rx="1.8" transform="matrix(-1 0 0 1 31 21.6)" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l4" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l4")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="19" height="17" rx="2" transform="matrix(-1 0 0 1 19 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.168 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.168 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.168 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 19.168 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.16797 20)" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "mc-l5" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l5")}>

                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 9 12)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 20 12)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 31 12)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 9 27)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 20 27)" fill="#8E9199" />
                                    <rect width="12" height="9" rx="2" transform="matrix(0 -1 -1 0 31 27)" fill="#8E9199" />
                                </svg>

                            </div>


                        </div>
                    </Col>
                    <Divider style={{ margin: "0px 0px", background: '#2D3343' }} />
                    <Col span={10}>
                        {/* <div className='lay-typ'>
                            More grids
                        </div> */}
                    </Col>
                    <Col span={14}>
                        <div className='display-1 gap-15'>
                            <div className={activeLay === "mc-l6" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l6")}>

                                <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="12" rx="2" fill="#8E9199" />
                                    <rect y="16" width="14" height="12" rx="2" fill="#8E9199" />
                                    <rect x="17" width="13" height="5" rx="2" fill="#8E9199" />
                                    <rect x="17" y="7" width="13" height="5" rx="2" fill="#8E9199" />
                                    <rect x="17" y="16" width="13" height="5" rx="2" fill="#8E9199" />
                                    <rect x="17" y="23" width="13" height="5" rx="2" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l7" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l7")}>


                                <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="12" rx="2" transform="matrix(-1 0 0 1 30 0)" fill="#8E9199" />
                                    <rect width="14" height="12" rx="2" transform="matrix(-1 0 0 1 30 16)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 0)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 7)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 16)" fill="#8E9199" />
                                    <rect width="13" height="5" rx="2" transform="matrix(-1 0 0 1 13 23)" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l8" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l8")}>

                                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="13" height="12" rx="2" fill="#8E9199" />
                                    <rect x="17" width="13" height="12" rx="2" fill="#8E9199" />
                                    <rect x="1" y="15" width="7" height="12" rx="2" fill="#8E9199" />
                                    <rect x="11" y="15" width="7" height="12" rx="2" fill="#8E9199" />
                                    <rect x="21" y="15" width="7" height="12" rx="2" fill="#8E9199" />
                                </svg>
                            </div>
                            <div className={activeLay === "mc-l9" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l9")}>
                                <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="13" height="12" rx="2" transform="matrix(1 0 0 -1 0 27)" fill="#8E9199" />
                                    <rect width="13" height="12" rx="2" transform="matrix(1 0 0 -1 17 27)" fill="#8E9199" />
                                    <rect width="7" height="12" rx="2" transform="matrix(1 0 0 -1 1 12)" fill="#8E9199" />
                                    <rect width="7" height="12" rx="2" transform="matrix(1 0 0 -1 11 12)" fill="#8E9199" />
                                    <rect width="7" height="12" rx="2" transform="matrix(1 0 0 -1 21 12)" fill="#8E9199" />
                                </svg>

                            </div>
                            <div className={activeLay === "mc-l10" ? "active d-flex" : "d-flex"} onClick={() => switchLayout("mc-l10")}>


                                <svg width="31" height="27" viewBox="0 0 31 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.17188 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 18.1719 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.1719 0)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.17188 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 18.1719 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.1719 10)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 8.17188 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 18.1719 20)" fill="#8E9199" />
                                    <rect width="8.16667" height="7" rx="2.33333" transform="matrix(-1 0 0 1 30.1719 20)" fill="#8E9199" />
                                </svg>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );

    return (
        <Dropdown
            overlay={customPanel}
            trigger={['click']}
            overlayStyle={{
                borderRadius: '16px',
                boxShadow: '0 4px 32px rgba(0,0,0,0.35)',
                background: '#212738',
            }}
            open={dropdownVisible}
            onOpenChange={setDropdownVisible}
        >
            {children}
        </Dropdown>
    )
}

export default LayoutDrop